import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { RelatedList, RelatedListItem, RelatedSettings } from 'components/RelatedSettings'
import { SelectOption } from 'components/Select'
import { CounterStyle } from 'features/globalSetup/api/types/counterStyle'
import { useGetCounterStyles } from 'features/globalSetup/pages/Defaults/RichPlacements/hooks/useGetCounterStyles'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'
import { WorkspaceDefaults } from '../useGetWorkspaceDefaults'

export const AppearanceWorkspaceDefaults = ({
  workspaceDefaults,
}: {
  workspaceDefaults: WorkspaceDefaults
}): React.JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.multiAnchor.workspaceDefaults',
  })
  const { workspaceId } = useWorkspaceParam()

  const { counterStyle, customStyling, fullWidthMode, showCloseButton } = workspaceDefaults

  const counterStyles = useGetCounterStyles()

  return (
    <RelatedSettings title={t('title')}>
      <RelatedList>
        <RelatedListItem
          content={t('counterStyle')}
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            section: 'multi-anchor',
            tab: 'rich-placements',
            workspaceId,
          })}
          value={
            counterStyles.find(
              ({ value }: SelectOption<CounterStyle>): boolean => value === counterStyle,
            )?.label
          }
        />

        <RelatedListItem
          content={t('showCloseButton')}
          value={tc(`booleanState.${showCloseButton}`)}
        />

        <RelatedListItem
          content={t('fullWidthMode')}
          value={tc(`booleanState.${fullWidthMode}`)}
        />

        <RelatedListItem
          content={t('customStyling')}
          value={tc(`definedState.${customStyling.length > 0}`)}
        />
      </RelatedList>
    </RelatedSettings>
  )
}
